import { copilotInstructions as s, copilotTools as i, copilotContext as u } from "./global-state.js";
import { prepareInstructionsForTransport as e, prepareToolsForTransport as a, prepareContextForTransport as r } from "./session.js";
function d(n, l, t = {}) {
  t = {
    instructions: t.instructions ?? [],
    context: t.context ?? [],
    includeGlobalContext: !0,
    includeGlobalTools: !0,
    includeGlobalInstructions: !0,
    ...t
  };
  const o = window.__hydra_copilot__?.generate;
  if (o == null)
    throw new Error("Copilot generate not configured. Please set the Copilot configuration first.");
  return o({
    message: n,
    schema: l,
    instructions: [
      ...t.includeGlobalInstructions ? e(s.get()) : [],
      ...e(t.instructions)
    ],
    tools: t.includeGlobalTools ? a(i.get()) : [],
    context: [
      ...t.includeGlobalContext ? r(u.get()) : [],
      ...r(t.context)
    ]
  });
}
export {
  d as generate
};
